import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the OpenLibraryProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OpenLibraryProvider {

  constructor(public http: HttpClient) {
  }

  public getBookData(isbn:string):Promise<any>{
    return fetch(`https://openlibrary.org/api/books?bibkeys=ISBN:${isbn}&format=json&jscmd=data`).then(res=>{return res.json()}).then(data =>{
      // console.log(data);
      if(data && data['ISBN:'+isbn]){
        return data['ISBN:'+isbn];
			}else{
				return false;
			}
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/open-library/open-library.ts